
import Vue from "vue";
import { genRandomAddress } from "@/api";

export default Vue.extend({
  name: "CreateWall",
  props: {
    msg: String,
  },
  data() {
    return {
      createWallInfoMessage: '',
    };
  },
  methods: {
    async createWall() {
      const address: string = genRandomAddress();
      if (typeof address === "undefined") return;
      this.createWallInfoMessage = `<a href="./#/wall/${address}">New wall</a> created`;
    },
  },
});
